// collection-stock-sort.js
// Re-sorts the product list by availability after each load-more append.
// In-stock (data-available="true") always floats above out-of-stock.

(function () {
  const list = document.querySelector('[data-product-list]');
  if (!list) return;

  function sortByAvailability() {
    const items = Array.from(list.querySelectorAll('li[data-available]'));
    const inStock = items.filter(li => li.dataset.available === 'true');
    const outOfStock = items.filter(li => li.dataset.available === 'false');
    [...inStock, ...outOfStock].forEach(li => list.appendChild(li));
  }

  // Sort on initial load
  sortByAvailability();

  // Re-sort whenever new items are appended
  const observer = new MutationObserver((mutations) => {
    const hasNewItems = mutations.some(m => m.addedNodes.length > 0);
    if (hasNewItems) sortByAvailability();
  });

  observer.observe(list, { childList: true });
})();